import { from, Observable, of } from "rxjs";
import { map, switchMap } from "rxjs/operators";
import { uuid } from "src/app/support/uuid";
import { UserNotify } from "../../../support/notify-decorator";
import { marker } from "@jsverse/transloco-keys-manager/marker";
import {
  loadDemoStorage,
  writeDemoStorage
} from "src/app/support/demo-storage";
import { WardBackend } from "./ward.backend";
import { Ward, WardCreate, WardDelete, WardLoad } from "../../models/ward";
import { find } from "lodash-es";

const DB_NAME = "ward";

export class WardMockBackend extends WardBackend {
  load(request: WardLoad): Observable<Ward> {
    return from(loadDb()).pipe(
      map((list) => find(list, (x) => x.id === request.id)!)
    );
  }

  list(): Observable<Ward[]> {
    return from(loadDb());
  }

  @UserNotify({
    successMessage: marker("Reparto creato"),
    errorMessage: marker("Impossibile creare il reparto")
  })
  create(data: WardCreate): Observable<string> {
    return from(loadDb()).pipe(
      switchMap((list) => {
        const newUuid = uuid();
        const newWard: Partial<Ward> = {
          id: newUuid,
          name: data.name
        };

        return from(writeDemoStorage(DB_NAME, [...list, newWard])).pipe(
          map(() => newUuid)
        );
      })
    );
  }

  @UserNotify({
    successMessage: marker("Reparto aggiornato"),
    errorMessage: marker("Impossibile aggiornare il reparto")
  })
  update(request: Ward): Observable<void> {
    return from(loadDb()).pipe(
      switchMap((list) => {
        return from(
          writeDemoStorage(
            DB_NAME,
            list.map((x) => {
              if (x.id === request.id) {
                return {
                  ...x,
                  ...request
                };
              }

              return x;
            })
          )
        );
      })
    );
  }

  @UserNotify({
    successMessage: marker("Reparto rimosso"),
    errorMessage: marker("Impossibile rimuovere il reparto")
  })
  delete(request: WardDelete): Observable<void> {
    return from(loadDb()).pipe(
      switchMap((list) => {
        return from(
          writeDemoStorage(
            DB_NAME,
            list.filter((x) => x.id !== request.id)
          )
        );
      })
    );
  }

  listByFacility(facilityUuid: string): Observable<Ward[]> {
    return of([]);
  }
}

async function loadDb(): Promise<Ward[]> {
  return (await loadDemoStorage<Ward[]>(DB_NAME)) || [];
}
